
import { ArrowLeft, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Investment } from "@/types/investment";

interface InvestmentDetailsHeaderProps {
  investment: Investment;
}

const InvestmentDetailsHeader = ({ investment }: InvestmentDetailsHeaderProps) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case "Open for Bidding":
        return "bg-green-100 text-green-800";
      case "Under Review":
        return "bg-yellow-100 text-yellow-800";
      case "Sold":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-blue-100 text-blue-800";
    }
  };

  return (
    <div className="mb-8">
      {/* Navigation */}
      <div className="mb-6">
        <Link to="/investor-portal">
          <Button variant="outline" size="sm">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Opportunities
          </Button>
        </Link>
      </div>

      {/* Property Image */}
      <div className="mb-6">
        {investment.thumbnail_image ? (
          <img 
            src={investment.thumbnail_image} 
            alt={investment.propertyAddress || investment.location}
            className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg"
          />
        ) : (
          <div className="w-full h-64 md:h-80 bg-gray-200 rounded-lg shadow-lg flex items-center justify-center">
            <div className="text-center text-gray-500">
              <MapPin className="h-12 w-12 mx-auto mb-2" />
              <p className="text-lg font-medium">Property Photo</p>
              <p className="text-sm">Image not available</p>
            </div>
          </div>
        )}
      </div>

      {/* Header Info */}
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <Badge className={getStatusColor(investment.status)}>
              {investment.status}
            </Badge>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {investment.type}
          </h1>
          
          <div className="flex items-center text-gray-600 mb-4">
            <MapPin className="h-4 w-4 mr-1" />
            <span>{investment.propertyAddress || investment.location}</span>
          </div>
          
          <p className="text-gray-700 leading-relaxed">
            {investment.propertyDescription || "Contact us for more details about this investment opportunity."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvestmentDetailsHeader;
